import {
  GET_COMPLAINTS_REQUEST,
  GET_COMPLAINTS_RESPONSE,
  GET_COMPLAINTS_FAILURE,
  GET_COMPLAINT_SLA_BADGES_RESPONSE,
  GET_ACCOUNT_COMPLAINTS_REQUEST,
  GET_ACCOUNT_COMPLAINTS_RESPONSE,
  GET_ACCOUNT_COMPLAINTS_FAILURE,
  UPDATE_COMPLAINT_REQUEST,
  UPDATE_COMPLAINT_RESPONSE,
  UPDATE_COMPLAINT_FAILURE,
  CREATE_COMPLAINT_REQUEST,
  CREATE_COMPLAINT_RESPONSE,
  CREATE_COMPLAINT_FAILURE,
  DELETE_COMPLAINT_REQUEST,
  DELETE_COMPLAINT_RESPONSE,
  DELETE_COMPLAINT_FAILURE,
  GET_COMPLAINT_NOTES_REQUEST,
  GET_COMPLAINT_NOTES_RESPONSE,
  GET_COMPLAINT_NOTES_FAILURE,
  CREATE_COMPLAINT_NOTE_RESPONSE,
  GET_COMPLAINT_FILES_REQUEST,
  GET_COMPLAINT_FILES_RESPONSE,
  GET_COMPLAINT_FILES_FAILURE,
  CREATE_COMPLAINT_FILE_RESPONSE,
  DELETE_COMPLAINT_FILE_RESPONSE,
  GET_COMPLAINT_STATUSES_RESPONSE,
  GET_COMPLAINT_TYPES_RESPONSE,
  SET_ACCOUNT_COMPLAINTS,
} from "./actions";

const complaintsInitialState = {
  isLoading: false,
  error: null,
  complaints: { items: [], total: 0 },
  accountComplaints: { items: [] },
  complaintNotes: [],
  complaintFiles: [],
  slaBadgeCounts: { overdue: 0, warning: 0 },
  complaintStatuses: [],
  complaintTypes: [],
};

export default (state = complaintsInitialState, action) => {
  switch (action.type) {
    case SET_ACCOUNT_COMPLAINTS:
      return {
        ...state,
        accountComplaints: action.newAccountComplaints,
      };

    case GET_COMPLAINTS_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case GET_COMPLAINTS_RESPONSE:
      if (!action.response || typeof action.response !== "object") {
        return {
          ...state,
          error: action.error ?? null,
          isLoading: false,
        };
      }
      return {
        ...state,
        complaints: {
          items: action.response.items ?? [],
          total: action.response.total ?? 0,
        },
        error: action.error ?? null,
        isLoading: false,
      };
    case GET_COMPLAINTS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };

    case GET_COMPLAINT_SLA_BADGES_RESPONSE:
      return {
        ...state,
        slaBadgeCounts: {
          overdue: Number(action.response?.overdue) || 0,
          warning: Number(action.response?.warning) || 0,
        },
      };

    case GET_ACCOUNT_COMPLAINTS_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case GET_ACCOUNT_COMPLAINTS_RESPONSE:
      var newAccountComplaints = { items: [] };
      if (action.response) {
        newAccountComplaints.items = action.response;
      }
      return {
        ...state,
        accountComplaints: newAccountComplaints,
        error: null,
        isLoading: false,
      };
    case GET_ACCOUNT_COMPLAINTS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };

    case UPDATE_COMPLAINT_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case UPDATE_COMPLAINT_RESPONSE:
      return {
        ...state,
        complaints: state.complaints
          ? {
              ...state.complaints,
              items: state.complaints.items.map((item) => {
                if (item.uuid == action.response.uuid) {
                  return action.response;
                }
                return item;
              }),
            }
          : { items: [], total: 0 },
        error: null,
        isLoading: false,
        updateSuccess: true,
      };
    case UPDATE_COMPLAINT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };

    case CREATE_COMPLAINT_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case CREATE_COMPLAINT_RESPONSE:
      if (state.complaints) {
        return {
          ...state,
          complaints: {
            ...state.complaints,
          },
          error: null,
          isLoading: false,
          updateSuccess: true,
        };
      } else {
        return {
          ...state,
          accountComplaints: {
            items: state.accountComplaints.items.concat(action.response),
          },
          error: null,
          isLoading: false,
          updateSuccess: true,
        };
      }
    case CREATE_COMPLAINT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };

    case DELETE_COMPLAINT_REQUEST:
      return {
        ...state,
        error: null,
        isLoading: action.isLoading,
      };
    case DELETE_COMPLAINT_RESPONSE:
      return {
        ...state,
        error: null,
        isLoading: false,
      };
    case DELETE_COMPLAINT_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };

    case GET_COMPLAINT_NOTES_REQUEST:
      return { ...state, isLoading: true };
    case GET_COMPLAINT_NOTES_RESPONSE:
      return { ...state, complaintNotes: action.response || [], isLoading: false };
    case GET_COMPLAINT_NOTES_FAILURE:
      return { ...state, error: action.error, isLoading: false };
    case CREATE_COMPLAINT_NOTE_RESPONSE:
      return {
        ...state,
        complaintNotes: [...state.complaintNotes, action.response],
        isLoading: false,
      };

    case GET_COMPLAINT_FILES_REQUEST:
      return { ...state, isLoading: true };
    case GET_COMPLAINT_FILES_RESPONSE:
      return { ...state, complaintFiles: action.response || [], isLoading: false };
    case GET_COMPLAINT_FILES_FAILURE:
      return { ...state, error: action.error, isLoading: false };
    case CREATE_COMPLAINT_FILE_RESPONSE:
      return {
        ...state,
        complaintFiles: [...state.complaintFiles, action.response],
        isLoading: false,
      };
    case DELETE_COMPLAINT_FILE_RESPONSE:
      return {
        ...state,
        complaintFiles: state.complaintFiles.filter((f) => f.uuid !== action.uuid),
        isLoading: false,
      };

    case GET_COMPLAINT_STATUSES_RESPONSE:
      return { ...state, complaintStatuses: action.response || [] };
    case GET_COMPLAINT_TYPES_RESPONSE:
      return { ...state, complaintTypes: action.response || [] };

    default:
      return { ...state };
  }
};
